import loadable from '@loadable/component';
export const loadableSketch = loadable(() => import('./Sketch'));
